$(document).ready(function () {
  bindSearchDrawerEvents()
})

function bindSearchDrawerEvents () {
  $('.open-search-drawer').each(function () {
    const openButton = $(this)
    const targetDrawer = openButton.attr('data-target-drawer') // Get drawer id

    // Open drawer
    openButton.on('click', function () {
      $('#' + targetDrawer).addClass('active')

      $(`#${targetDrawer} input[type="text"]`).focus()

      // Hide the bg-overlay if another one is already open
      if ($('.search-drawer.active .bg-overlay').length > 1) {
        $('#' + targetDrawer).find('.bg-overlay').hide()
      }
    })
  })

  // Close drawer on click (background or close-btn)
  $('.search-drawer .bg-overlay , .search-drawer .close-btn , .close-all-drawers').on('click', function () {
    closeAllDrawers()
  })

  // Close drawer on click (background or close-btn)
  $('.close-this-drawer').on('click', function () {
    const thisDrawer = $(this).closest('.search-drawer')
    closeThisDrawer(thisDrawer)
  })

  // Close all drawers on press ESC
  $(this).on('keyup', function (e) {
    if (e.key == 'Escape') {
      closeAllDrawers()
    }
  })

  // Close all drawers function
  function closeAllDrawers () {
    $('.search-drawer').removeClass('active')
  }

  // Close only one drawer function
  function closeThisDrawer (drawer) {
    drawer.removeClass('active')
  }

  function resizedw () {
    $('.search-drawer .content').css('opacity', 1)
  }

  var doit
  window.onresize = function () {
    $('.search-drawer .content').not('.search-drawer.active .content').css('opacity', 0)
    clearTimeout(doit)
    doit = setTimeout(resizedw, 800)
  }

  // Look for "button-wrapper" inside drawers and add a class to its parent "level"
  $('.search-drawer .level .for-form .button-wrapper').each(function () {
    $(this).closest('.level').addClass('hasButtons')
  })

  // Look for "bruk" button inside drawers and add a class to its parent "level"
  $('.search-drawer .level .btn.bruk').each(function () {
    $(this).closest('.level').addClass('hasButtons hasButtons--bruk')
  })

  searchOnDrawerHandler()
}

function searchOnDrawerHandler () {
  $('.search-drawer .btn-clear').on('click', function () {
    const value = ''
    $(this).closest('.search-drawer').find('.link-list li').filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    })
  })

  $('.search-drawer input').on('keyup', function () {
    const value = $(this).val().toLowerCase()
    $(this).closest('.search-drawer').find('.link-list li').filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    })
  })
}

// Add workplace (FOR-419)
// Close "add-workplace-dialog"
$('.add-workplace-dialog .close-dialog').on('click', function () {
  $(this).closest('.add-workplace-dialog').hide()
})
